import React from 'react';
import CreateIconComponent, { CreateIconComponentProps } from '../CreateIconComponent';

enum ArrowRotation {
  'up' = 90,
  'down' = -90,
  'left' = 0,
  'right' = 180,
}

export const ArrowIcon = ({
  title = 'Arrow',
  direction = 'right',
  ...props
}: CreateIconComponentProps): JSX.Element => (
  <CreateIconComponent
    title={title}
    viewBox="0 0 10 8"
    rotateDeg={ArrowRotation[direction]}
    {...props}
  >
    {/* prettier-ignore */}
    <path d="M0 4.00773C0 4.25712 0.102077 4.48074 0.263784 4.64357L3.28366 7.72279C3.44335 7.89179 3.66468 8 3.91331 8C4.39641 8 4.78754 7.60015 4.78754 7.10756C4.78754 6.86745 4.69253 6.65001 4.53992 6.49027L2.98147 4.89605L9.1096 4.89605C9.11465 4.89605 9.11971 4.89914 9.12577 4.89914C9.60887 4.89914 10 4.50032 10 4.00773C10 3.5172 9.6119 3.12147 9.13184 3.11735L2.97844 3.11529L4.53689 1.52724L4.53386 1.52415C4.69455 1.36236 4.7936 1.13873 4.7936 0.891408C4.7936 0.398815 4.40247 0 3.91836 0C3.66468 0 3.44133 0.113358 3.28164 0.288548L0.251657 3.37808C0.0980349 3.5409 0 3.76246 0 4.00773Z" />
  </CreateIconComponent>
);

export default ArrowIcon;
